import { factory } from '@opten/compiler/factory';
import '../../Opten.HypothekarbankLenzburg.Core.Static//utilities/polyfills';
import './finstar.scss';

import { Component } from '@opten/compiler/metadata/component';
import { stickToParent } from '@opten/sticky/stick-to-parent';

import { CollapseComponent } from '@opten/collapse';
import cookieConsent from '../../Opten.HypothekarbankLenzburg.Core.Static/components/cookie-consent';
import InputFieldsFilled from '../../Opten.HypothekarbankLenzburg.Core.Static/components/input-fields-filled';
import { Player } from '../../Opten.HypothekarbankLenzburg.Core.Static/components/player/player';

import Datepicker from '../../Opten.HypothekarbankLenzburg.Core.Static/components/datepicker';
import recaptchaValidator from '../../Opten.HypothekarbankLenzburg.Core.Static/components/recaptcha';
import recaptcha3Validator from '../../Opten.HypothekarbankLenzburg.Core.Static/components/recaptcha-3';
import { SelectComponent } from '../../Opten.HypothekarbankLenzburg.Core.Static/components/select/select';
import { Anchor } from './components/anchor';
import { MagicScrollComponent } from './components/magic-scroll';

import { Navbar, NavbarToggler } from './components/navbar';

import { Header } from './components/header/header';

import { BackToTopComponent } from './components/back-to-top/back-to-top';

import filterpage from '../../Opten.HypothekarbankLenzburg.Core.Static/components/filterpage';
import Photoswipe from '../../Opten.HypothekarbankLenzburg.Core.Static/components/photoswipe/photoswipe';
import { NavigationHideScrollDownShowScrollUpComponent } from './components/back-to-top/navigation';
import { DotsPictureComponent } from './components/dots-picture/dots-picture';
import { LanguageChooserComponent } from './components/language-chooser';
import { MasonryComponent } from './components/masonry/masonry';

@Component({ className: 'js-recaptcha', observe: true })
class RecaptchaValidator {
	constructor(private element: HTMLElement) {
		recaptchaValidator(element);
	}
}

@Component({ className: 'js-recaptcha-3', observe: true })
class Recaptcha3Validator {
	constructor(private element: HTMLInputElement) {
		recaptcha3Validator(element);
	}
}

@Component({ className: 'js-filter__page' })
class FilterPage {
	constructor(private element: HTMLElement) {
		filterpage(element, {
			scrollToTopAfterFiltering: false,
			hasStickyOffsetDesktop: false
		});
	}
}

@Component({ className: 'js-stick-to-parent-padding-parent-nav' })
class StickToParentNav {
	constructor(private element: HTMLElement) {
		stickToParent(element, {
			offsetTop: 0,
			offsetTopMobile: 75,
			withPaddingParent: true,
			enableForMobile: true,
			mobileWidth: 1199,
			stickyClass: 'is--sticky'
		});
	}
}

@Component({ className: 'js-cookie-consent' })
class CookieConsent {
	constructor(private element: HTMLElement) {
		/*const header = document.getElementsByClassName(
            'js-header'
        )[0] as HTMLElement;*/
		const connectionIsSecure = element.hasAttribute('data-cookie-secure')
			? element.getAttribute('data-cookie-secure').toLowerCase() ===
			  'true'
			: true;
		cookieConsent([], {
			showAfter: 600,
			cookie: {
				expirationInDays: 365,
				secure: connectionIsSecure
			}
		});
	}
}

@Component({ className: 'js-form__field-accept', observe: true })
class FormFieldAccept {
	constructor(private element: HTMLElement) {
		if (element.hasAttribute('data-id')) {
			element.addEventListener('click', () => {
				const id = element.getAttribute('data-id');
				const checkbox = document.querySelector<HTMLInputElement>(
					'[id="' + id + '"]'
				);

				if (checkbox) {
					checkbox.checked = true;
				}
			});
		}
	}
}

factory([
	LanguageChooserComponent,
	StickToParentNav,
	CollapseComponent,
	DotsPictureComponent,
	MasonryComponent,
	Player,
	CookieConsent,
	SelectComponent,
	Header,
	Navbar,
	NavbarToggler,
	NavigationHideScrollDownShowScrollUpComponent,
	BackToTopComponent,
	InputFieldsFilled,
	FormFieldAccept,
	RecaptchaValidator,
	Recaptcha3Validator,
	FilterPage,
	Datepicker,
	MagicScrollComponent,
	Anchor,
	Photoswipe
])(document.body);
